import { HeadlinePage, SearchBarBox, TableCustom } from 'components/common';
import React from 'react'
import { useForm } from 'react-hook-form';
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import {useTranslation} from "react-i18next";
import { Paper } from "@mui/material";

const RoleListDumb = ({
  isLoaded,
  content,
  handleCreate,
  handleDelete,
  handleEdit,
  handleSearch,
  searchValue
}) => {

  const methods = useForm();
  const [t] = useTranslation();

  const onSubmit = (data) => {
    handleSearch(data);
  };

  const onDelete = (role) => {
    handleDelete(role);
  };

  const onEdit = (role) => {
    handleEdit(role);
  };

  const columns = [
    { label: 'Name', key: 'label' },
    { label: 'Description', key: 'text' },
  ];

  const actions = [
    {
      label: t('roleList.components.table.edit'),
      icon: <EditOutlinedIcon color="primary" />,
      handle: onEdit,
    },
    {
      label: t('roleList.components.table.delete'),
      icon: <HighlightOffIcon color="primary" />,
      handle: onDelete,
    },
  ];



  return (
    <>
      <HeadlinePage
        title="roleList.headline"
        buttonLabel="roleList.components.add"
        handleOnClick = { handleCreate }
      />

      <SearchBarBox
        onSubmit={ onSubmit }
        methods={ methods }
        hideProject={ true }
        searchValue={searchValue}
      />

      <Paper sx={{ p: 2 }}>
        <TableCustom
          title="roleList.components.titleList"
          columns={columns}
          content={content}
          actions={actions}
          loading={isLoaded}
          handleNotResults={handleCreate}
        />
      </Paper>
    </>
  )
}

export default RoleListDumb;
